export default "__VITE_ASSET__CmbFCL6O__"